export default "__VITE_ASSET__76753062__"